import { TrainingMember } from '@/app/models/detailsTraining';
import DataTable, { bodyCellSx, Column } from '@/components/common/DataTable';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, TableCell, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ProjectTableProps {
  persons: TrainingMember[];
  onRemove?: (projectId: number) => void;
}

export default function ProjectTable({ persons, onRemove }: ProjectTableProps) {
  const { t } = useTranslation(['training', 'common']);
  const theme = useTheme();

  const handleDelete = (projectId: number) => {
    if (onRemove) {
      onRemove(projectId);
    }
  };

  const columns: Column[] = [
    {
      key: 'collaborator',
      label: t('common:collaborator'),
    },
    {
      key: 'actions',
      label: t('common:actions'),
      align: 'right',
    },
  ];

  const renderRow = (person: TrainingMember) => (
    <>
      <TableCell sx={bodyCellSx}>{`${person.name}`}</TableCell>
      <TableCell align="right" sx={bodyCellSx}>
        {onRemove && (
          <IconButton size="small" onClick={() => handleDelete(person.id)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </TableCell>
    </>
  );

  return (
    <DataTable
      columns={columns}
      data={persons}
      renderRow={renderRow}
      emptyMessage={t('no.collaborators.assigned')}
      getRowKey={(item) => item.id}
      size="small"
      maxHeight={theme.spacing(50)}
      stickyHeader={false}
    />
  );
}
